//#region [IMPORT]

// === THIRD-PARTY ===
import { useEffect, useState } from "react";

// === API ===
import { on, onTaskUpdate, removeListener } from "api/prokey/prokey.websocket";

//#endregion

//-----------------------------------------------------------------
export function useTaskUpdate() {
  //-----------------------------------------------------------------
  
  //#region [VALUES]

  const [ updates , setUpdates ] = useState( { documents: {} } );

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    
    //-----------------------------------------------------------------
    function handleTaskUpdate(data) {
      //-----------------------------------------------------------------
      if( !data?.documents ) return;
      if( Object.keys( data.documents ).length <= 0 ) return;
      setUpdates( { documents: data.documents } );
    }
    
    //-----------------------------------------------------------------
    function handleDocumentOrder(data) {
      //-----------------------------------------------------------------
      if( !data?.updates ) return;
      setUpdates( { ...data.updates } );
    }
    
    //-----------------------------------------------------------------
    function handleImageMove(data) {
      //-----------------------------------------------------------------
      if( !data?.updates ) return;
      setUpdates( { ...data.updates } );
    }

    onTaskUpdate( handleTaskUpdate );
    on( 'DOCUMENT-ORDER', handleDocumentOrder );
    on( 'IMAGE-MOVE'    , handleImageMove     );

    return () => {
      removeListener( 'TASK-UPDATE'   , handleTaskUpdate    );
      removeListener( 'DOCUMENT-ORDER', handleDocumentOrder );
      removeListener( 'IMAGE-MOVE'    , handleImageMove     );
    }
  }, [] );

  //#endregion

  return updates;
};